export class alertModal{
    type: string;
    message: string;
}